import React from "react";
import { HintView } from "lib/components/index";

const Hint = () => (
  <HintView.Hint>
    <p>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p1")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p2")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p3")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p4")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p5")}</p>

    <h3>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p6")}</h3>
    <p>{I18n.t("papp.products.EditProductView.StepBookingSettings.hint.p7")}</p>
  </HintView.Hint>
);

export default Hint;



// WEBPACK FOOTER //
// ./src/modules/products/EditProductView/StepBookingSettings/StepBookingSettingsHint.jsx